//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'mp-menu-group',
  props: {
    menu: {
      type: Object,
      default: () => ({})
    },
    level: {
      type: Number,
      default: 0
    }
  },
  data: () => ({isActive: null}),
  computed: {
    group() {
      return this.genGroup(this.menu.children);
    }
  },
  methods: {
    genGroup(menuChildren) {
      return menuChildren.reduce((acc, cur) => {
        acc.push(cur.children && cur.children.length > 0 ? this.genGroup(cur.children) : cur.path);
        return acc;
      }, []).join('|');
    }
  }
}
